import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProfileIconActive = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.04232 5.0013C6.04232 2.81518 7.81453 1.04297 10.0007 1.04297C12.1868 1.04297 13.959 2.81518 13.959 5.0013C13.959 7.18743 12.1868 8.95964 10.0007 8.95964C7.81453 8.95964 6.04232 7.18743 6.04232 5.0013Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.45898 11.043C4.83563 11.043 2.70898 13.1696 2.70898 15.793C2.70898 17.5419 4.12675 18.9596 5.87565 18.9596H14.1257C15.8746 18.9596 17.2923 17.5419 17.2923 15.793C17.2923 13.1696 15.1657 11.043 12.5423 11.043H7.45898Z",
		fill: "currentColor"
	})]
});
export default SvgProfileIconActive;
